/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon16Regular = forwardRef('MediaUiASkipBackIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 3a.75.75 0 0 1 1.5 0v4.668c.076-.303.257-.583.544-.78l6.341-4.36a1.35 1.35 0 0 1 2.115 1.113v8.718a1.35 1.35 0 0 1-2.115 1.113l-6.34-4.36a1.336 1.336 0 0 1-.545-.78V13a.75.75 0 0 1-1.5 0V3Zm3.074 5 5.926 4.074V3.926L6.324 8Z" })));
});
